import styled from 'styled-components';

import { IconButton } from '../../../cdl/IconButton/IconButton';
import { Text } from '../../../cdl/Text/Text';
import { translate } from '../../../common/helpers/translate.helper';
import { IconChevronDown } from '../../../common/icons/cdl/ChevronDown';
import { IconChevronRight } from '../../../common/icons/cdl/ChevronRight';
import { theme } from '../../../common/ui/theme';

interface HeaderProps {
    isOpen: boolean;
}

const Header = styled.div<HeaderProps>`
    background-color: ${(props) => (props.isOpen ? theme.colors.background.subtle : 'transparent')};
    border-style: solid;
    border-width: 1px;
    border-color: ${theme.colors.border.muted};
    padding: ${theme.space[8]};
    height: 48px;
    display: grid;
    justify-items: start;
    grid-template-columns: 32px 1fr;
    grid-column-gap: ${theme.space[8]};
    align-items: center;
    user-select: none;
    cursor: pointer;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    border-bottom-right-radius: ${(props) => (props.isOpen ? '0px' : '6px')};
    border-bottom-left-radius: ${(props) => (props.isOpen ? '0px' : '6px')};

    &:hover {
        background-color: ${theme.colors.background.subtle};
    }
`;

interface OrderedProductsProps {
    isOpen: boolean;
    onClick: () => void;
}

export const EnquiredProductsAccordionHeader = ({ isOpen, onClick }: OrderedProductsProps) => {
    return (
        <Header isOpen={isOpen} onClick={onClick}>
            <IconButton Icon={isOpen ? IconChevronDown : IconChevronRight} />

            <Text variant="small" color="accent.foreground">
                {isOpen ? translate('order.hideEnquiredProducts') : translate('order.showEnquiredProducts')}
            </Text>
        </Header>
    );
};
